import React from 'react';
import BrandedButton, { BrandedButtonProps } from '../../../Buttons/BrandedButton';
import { useDropdownToggleProps } from '../../hooks/useDropdownToggleProps';
import type { ComponentRequiresAriaHasPopup } from '../types';

export interface Props
  extends Omit<BrandedButtonProps, 'aria-haspopup'>, ComponentRequiresAriaHasPopup {}

/**
 * A wrapper around our DS `BrandedButton` that provides the props for a dropdown toggle.
 *
 * Note: This component is only the toggle! It doesn't contain a popover or dropdown. If you're looking for something that does,
 * you probably want a preset instead of this. Consider `BrandedButtonWithContextMenu`.
 *
 * Required contexts: `PopperDropdownContext`, `DropdownStateContext`
 */
const PopperBrandedToggleButton: React.FC<Props> = props => {
  const necessaryToggleProps = useDropdownToggleProps();

  return <BrandedButton {...necessaryToggleProps} {...props} />;
};
PopperBrandedToggleButton.displayName = 'PopperBrandedToggleButton';

export default PopperBrandedToggleButton;
